/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="30" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="50" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="70" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="90" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="110" rx="5" ry="5" width="350" height="15" />
      <rect x="1" y="130" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="150" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="170" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="200" rx="5" ry="5" width="500" height="15" />
      <rect x="1" y="220" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="240" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="260" rx="5" ry="5" width="250" height="15" />
      <rect x="1" y="290" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="310" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="330" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="350" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="370" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="390" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="410" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="430" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="450" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="470" rx="5" ry="5" width="390" height="15" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="30" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="50" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="70" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="90" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="110" rx="5" ry="5" width="350" height="15" />
      <rect x="1" y="130" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="150" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="170" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="200" rx="5" ry="5" width="500" height="15" />
      <rect x="1" y="220" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="240" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="260" rx="5" ry="5" width="250" height="15" />
      <rect x="1" y="290" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="310" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="330" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="350" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="370" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="390" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="410" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="430" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="450" rx="5" ry="5" width="585" height="15" />
      <rect x="1" y="470" rx="5" ry="5" width="390" height="15" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
